//basic
import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//api
import { api } from '../../functions/api';

//custom components
import CustomTable from '../../components/complex/customTable';
import Search from '../../components/basic/search';
import CustomButton from '../../components/basic/CustomButton';

import ChangeSiblingsPositions from './ChangeSiblingsPositions/ChangeSiblingsPositions';
import AddEditItem from './AddEditItem/AddEditItem';
import DeleteDialog from '../../components/global/deleteDialog';



//material-ui
import { CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

//style
import './Menu.scss';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';
import removeAccents from 'remove-accents';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';

const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiInput: {
            underline: {
                "&::after": {
                    borderBottomColor: "#777777",
                    borderBottom: "2px solid #777777 !important"
                }
            },
        },
        MuiFormControl: {
            root: {
                marginLeft: "2px",
                marginRight: "5px"
            }
        }
    }
})


@inject('internal')
@inject('translate')
@observer
export default class Menu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            loadingTable: false,
            siblingsDialog: false,
            addEditDialog: false,
            typeMenu: "top",
            shop_id: 2,
            allData: null
        }
    }

    // definujeme ci sa ma reloadnut tabulka
    tableReload = false;

    // counter ktori sa zvacsuje pri kazdom api cale okrem pri mounte modulu
    // nedovuje aby sa tabulka zobrazila skor ako co pride aj posledna odpoved zo servera
    apiCallCounter = 0;

    componentDidMount() {
        const { user } = toJS(this.props.internal)

        if(user && user.data && user.data.permissions && user.data.permissions.lists_frontend_menu && user.data.permissions.lists_frontend_menu.view) {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname);
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.MENU);
            this.setPermissions()
            const URLqueryString = this.props.history.location.search
            let queries = queryString.parse(URLqueryString)
            if(queries.menu_position) {
                this.setState({typeMenu: queries.menu_position})
                this.addQueryToUrl("menu_position", queries.menu_position);
            }
            else {
                this.addQueryToUrl("menu_position", "top");
            }
    
            // this.addQueryToUrl("shop_id", "1");
            
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }
    
    componentWillReceiveProps() {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);
        if(Number(this.props.match.params.idShop) !== this.state.shop_id) {
            this.setState({shop_id: Number(this.props.match.params.idShop), loadingPage: true})
            if(queries.menu_position) {
                this.setState({typeMenu: queries.menu_position})
                this.addQueryToUrl("menu_position", queries.menu_position);
            }
            else {
                this.addQueryToUrl("menu_position", "top");
            }

        }
    }

    loadMenuItems = async (size = 100, page = 0, searchterm = "", by = "name", dir = "asc") => {

        if(this.tableReload) {
            this.setState({loadingTable: true})
            this.apiCallCounter++;
        }
        
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        let menu_position = '';
        let shop_id = ""

        let params = {
            searchterm: searchterm,
            // page:{
            //     number:page,
            //     size:size,
            // },
            // order: [
            //     {
            //         by: by,
            //         dir: dir
            //     }
            // ]
        }

        let filters = {}

        shop_id = Number(this.props.match.params.idShop)
        filters.shop_id = shop_id
        params.filters = filters

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                params.searchterm = queries.searchterm
            }

            if(queries.menu_position) {
                menu_position = queries.menu_position;
                filters.menu_position = menu_position
                params.filters = filters
            }

            if(queries.shop_id) {
                shop_id = queries.shop_id;
                filters.shop_id = shop_id
                params.filters = filters
            }
        }
        

        let load_data = await api({
            method:'get',
            url: 'lists/frontend-menu',
            authorization: this.props.internal.user.access_token,
            params: params
        })


        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
                this.setState({allData: load_data.data})
            }
        }
        this.setState({loadingPage: false})

        if(this.tableReload) {
            this.apiCallCounter--;
            if(this.apiCallCounter === 0) {
                this.setState({loadingTable: false})
                this.tableReload = false;
            }
        }
        
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = (searchTerm) => {

        searchTerm = removeAccents(searchTerm).toLowerCase()

        const { data } = this.state.allData

        let result = data.filter(item => removeAccents(item.name).toLowerCase().includes(searchTerm) && item.menu_position === this.state.typeMenu)
        this.props.internal.setResultDataForTable(result)
        
        if(searchTerm === '') {
            this.props.internal.setResultDataForTable(this.state.allData.data)
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        this.tableReload = true;

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadMenuItems()
    }

    handleDelete = async () => {
        let idMenuItem = toJS(this.props.internal.actionDeleteObj.id)
        let delete_menut_item = await api({
            method: 'delete',
            url: `lists/frontend-menu/${idMenuItem}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_menut_item.success === true) {
            this.props.internal.setSnackbar(delete_menut_item.data.message, true)
            this.loadMenuItems();
            this.props.internal.setActionDelete();
        }
    }

    tableHeader = [
        {
            "title": "title",
            "numeric": false,
            "min_width": "150px",
            
        },
        {
            "title": "menu_type",
            "numeric": false
        },
        {
            "title": "published_from",
            "numeric": false,
            "min_width": "100px"
        },
        {
            "title": "published_until",
            "numeric": false,
            "min_width": "100px"
        },
        {
            "title": "active",
            "numeric": false,
            "textAlign": "center"
        },
        {
            "title": "position",
            "numeric": false,
            "textAlign": "center"
        }
    ];
    tableBody = [
        "name",
        "frontend_menu_type_id",
        "published_from",
        "published_until",
        "production",
        "id"
    ]

    setPermissions () {
        const { user } = toJS(this.props.internal)
        
        if(user && user.data && user.data.permissions && user.data.permissions.lists_frontend_menu) {
            if(user.data.permissions.lists_frontend_menu.update) {
                this.dropDownMenuItems.push(
                    {
                        title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
                        action: "edit"
                    },
                )
            }

            if(user.data.permissions.lists_frontend_menu.destroy) {
                this.dropDownMenuItems.push(
                    {
                        title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
                        action: "delete"
                    },
                )
            }
        }
    }

    dropDownMenuItems = [
        // {
        //     title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
        //     action: "edit"
        // },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // },
    ];

    openCloseDialogChangePosition = () => {
        const { user } = toJS(this.props.internal)
        
        if(user && user.data && user.data.permissions && user.data.permissions.lists_frontend_menu && user.data.permissions.lists_frontend_menu.update) {
            this.setState({siblingsDialog: !this.state.siblingsDialog})
            this.loadMenuItems()
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    //dialog pre vytvorenie/upravenie polozky menu
    handleOpenCloseDialog = async(refresh = false, article_id = null) => {
        
        let actionEdit = toJS(this.props.internal.actionEdit)
        if(actionEdit.edit) {
            actionEdit = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEdit)
        }
        else {
            this.setState({addEditDialog: !this.state.addEditDialog})
        }

        if(article_id === null && refresh) {
            await this.loadMenuItems()
        }
        else if(article_id !== null) {

            this.props.internal.pushRoute(`/${this.state.shop_id}/menu/article/${article_id}`)
        }
    }

    //z tabulki prichadzaju data, na kotry riadok bolo kliknute a aka bola zvolena hodnota
    updateTypeMenuItem = async(e,data) => {
        // this.updateTypeMenuItem(e.target.value, toJS(data.id));
        const { user } = toJS(this.props.internal)
        
        if(user && user.data && user.data.permissions && user.data.permissions.lists_frontend_menu.update) {
            let idMenu = toJS(data.id);
            let frontend_menu_type_id = e.target.value;
            let update_data = await api({
                method:'patch',
                url: `lists/frontend-menu/${idMenu}`,
                authorization: this.props.internal.user.access_token,
                params: {
                    frontend_menu_type_id: frontend_menu_type_id
                }
            })

            if(update_data.success === true ) {
                this.props.internal.setSnackbar(update_data.data.message, true)
                this.loadMenuItems()
            }
            else{
                this.props.internal.setSnackbar(update_data.data.message, true)
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    handleChangePosition = typeMenu => {
        this.setState({typeMenu: typeMenu.target.value})
        this.addQueryToUrl("menu_position", typeMenu.target.value)
    }

    changeProductionStatus = async(id, status) => {
        const { user } = toJS(this.props.internal)
        
        if(user && user.data && user.data.permissions && user.data.permissions.lists_frontend_menu.update) {
            let update_data = await api({
                method:'patch',
                url: `lists/frontend-menu/${id}`,
                authorization: this.props.internal.user.access_token,
                params: {
                    production: status
                }
            })

            if(update_data.success === true ) {
                this.props.internal.setSnackbar(update_data.data.message, true)
                this.loadMenuItems()
            }
            else{
                this.props.internal.setSnackbar(update_data.data.message, true)
            }
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
    }

    setMenuPosition = (menuPosition) => {
        this.setState({typeMenu: menuPosition})
        // this.addQueryToUrl("menu_position", menuPosition)
    }

    handleChangeShop = shop_id => {
        this.setState({shop_id: shop_id.target.value})
        this.addQueryToUrl("shop_id", shop_id.target.value)
    }

    render () {
        const { user } = toJS(this.props.internal)
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'menu-bekoshop'}>
                    {/* zmena poradia prvkov v menu */}
                    <ChangeSiblingsPositions
                        open={this.state.siblingsDialog}
                        onClose={this.openCloseDialogChangePosition}
                        title={this.props.translate.i18n.MODULES.CATEGORIES.DIALOG_TITLE_CHANGE_SIBLINGS_POSITIONS}
                        childs={this.props.internal.dataForTable.data}
                    />
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.MENU.DELETE_MENU_ITEM_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />

                    {(this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)) &&
                        <AddEditItem
                            open={this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.state.addEditDialog ? this.props.translate.i18n.MODULES.MENU.DIALOG_TITLE_CREATE : this.props.translate.i18n.MODULES.MENU.DIALOG_TITLE_EDIT}
                            typeMenu={this.state.typeMenu}
                            setMenuPosition={this.setMenuPosition}
                            shop={this.state.shop_id}
                        />
                    }
                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        {user && user.data && user.data.permissions && user.data.permissions.lists_frontend_menu && user.data.permissions.lists_frontend_menu.store ?
                            <CustomButton
                                mystyle = {'btn-orange-bg border-radius-18'}
                                title = {this.props.translate.i18n.MODULES.MENU.CREATE_NEW_ITEM_MENU}
                                onClick = {this.handleOpenCloseDialog}
                            >
                                <Icon path = {mdiPlus} size = {1}/>
                            </CustomButton>
                            :
                            null
                        }
                    </div>
                    <MuiThemeProvider theme={materialTheme}>
                        <FormControl className="select-type-position">
                            <InputLabel
                                htmlFor="menu-position"
                                className={"label-select-type"}
                                // shrink={true}
                            >
                                {this.props.translate.i18n.MODULES.MENU.MENU_POSITION_LABEL}
                            </InputLabel>
                            <Select
                                classes={{
                                    root: "select-menu-position-root",
                                }}
                                value={this.state.typeMenu}
                                onChange={this.handleChangePosition}
                                inputProps={{
                                    name: "menu_position",
                                    id: "menu-position",
                                }}
                                // displayEmpty
                            >
                                <MenuItem value="top">{this.props.translate.i18n.MODULES.MENU.MENU_POSITION.MAIN}</MenuItem>
                                <MenuItem value="bot">{this.props.translate.i18n.MODULES.MENU.MENU_POSITION.BOTTOM}</MenuItem>
                            </Select>
                        </FormControl>
                        {/* <FormControl className="select-type-position">
                            <InputLabel
                                htmlFor="select-shop"
                                className={"label-select-type"}
                                // shrink={true}
                            >
                                {this.props.translate.i18n.MODULES.MENU.SHOP}
                            </InputLabel>
                            <Select
                                classes={{
                                    root: "select-menu-position-root",
                                }}
                                value={this.state.shop_id}
                                onChange={this.handleChangeShop}
                                inputProps={{
                                    name: "select-shop",
                                    id: "select-shop",
                                }}
                                // displayEmpty
                            >
                                {toJS(this.props.internal.dataForTable.lists.shops).map((shop, index) => {
                                    return (<MenuItem key={index} value={shop.id}>{shop.name}</MenuItem>);
                                })}
                            </Select>
                        </FormControl> */}
                    </MuiThemeProvider>
                    {this.state.loadingTable
                        ?
                        <CircularProgress className={'circular-progress'} />
                        :
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/menu'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                            openDialogSiblings={this.openCloseDialogChangePosition}
                            updateTypeMenuItem={this.updateTypeMenuItem}
                            clickOnProductionStatus={this.changeProductionStatus}
                            disablePagination
                            disableSort
                        />
                    }
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/menu/Menu.jsx